export const ERROR_MSG_CODES = {
  SL_PRICE_WARNING: 10001, // sl price warning
  SL_PRICE_ERROR: 10002, // sl price error
};
